<template lang="pug">
//- 2022-04-15 height要求写死1200，原100%
.content
    div.iframe-header
        TableTitle(slot="icon", icon="fa fa-list", title="权限申请")
    iframe(
      src="https://registry.dmp.360.cn/registry/add?product=4&from=360fenxi",
      frameborder="0",
      width="100%",
      height= "1200",
      scrolling="no")
</template>
<script>
export default {
  mounted () {
    window.addEventListener('message', this.listener)
  },
  destroyed () {
    window.removeEventListener('message', this.listener)
  },
  methods: {
    listener (e) {
      if (typeof e.data === 'number') {
        // 2022-04-15 要求写死1200
        // document.querySelector('iframe').height = e.data;
      } else if (e.data === 'form save success') {
        this.$router.push('/setting/sites')
      } else if (e.data === 'form save cancel') {
        this.$router.push('/infoguide')
      }
    }
  }
}
</script>
<style scoped>
.iframe-header {
  background-color: #fff;
  border-bottom: 1px solid rgb(227, 227, 227);
  padding: 5px 15px;
}
iframe {
  min-height: 500px;
}
.content {
  padding: 0;
  margin: 0;
  padding-top: 60px;
}
</style>



// WEBPACK FOOTER //
// nopermission.vue?77f76dfc